import { Breadcrumbs, IconButton, Link, styled, Typography } from "@mui/material";
import { BackButton } from "../../../../../common/components/back_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import FormContainer from "../../../../../common/components/form_container";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import { isValidId } from "../../../../../common/utils/utils";
import { DefaultFormAutocomplete } from "../../../../../common/components/default_form_autocomplete";
import { DefaultFormRadioGroupInput } from "../../../../../common/components/default_form_radio_group_input";
import { useMemo } from "react";
import { DropDownFornecedor } from "../../../../../common/components/dropdown_fornecedor";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { DefaultFormMoneyInput } from "../../../../../common/components/default_form_money_input";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { useManutencaoGerenciarCadastroViewModel } from "../../viewModels/manutencao_gerenciar_cadastro_view_model";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { Controller } from "react-hook-form";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const ManutencaoGerenciarCadastro = () => {

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const viewModel = useManutencaoGerenciarCadastroViewModel();

  const analiseOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Em Aberto',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Andamento',
        style: {
          backgroundColor: '#f1c40f',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 2,
        label: 'Reprovado',
        style: {
          backgroundColor: '#f3565d',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 3,
        label: 'Finalizado',
        style: {
          backgroundColor: '#3498db',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      }

    ];
  }, [
  ]);


  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <BackButton onClick={() => window.history.back()} />
            </div>
          }
        />
      </PageTopBar>

      <form onSubmit={viewModel.handleSubmitManutencao}>
        <div className=" flex w-full gap-6 flex-col md:p-10 px-4 pt-8 mb-16 ">
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit">
              Manutenção
            </Link>
            <Typography className="text-primary-green ">Gerenciar Solicitação de Manutenção</Typography>
          </Breadcrumbs>

          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium dark:dark:text-zinc-100 ">
              Gerenciar Solicitação de Manutenção
            </h1>
            <RefreshButton onClick={viewModel.handleReloadPage} />
          </div>

          <div className="flex gap-2 items-center w-full">
            {viewModel.selectedManutencao && (
              <div className="w-full mt-3 text-black dark:text-white p-4 rounded-xl bg-gray-100 dark:bg-gray-800 shadow-sm">
                <div className="text-lg">
                  <span className="font-semibold mr-2">Número:</span>
                  <span className="font-bold">{viewModel.selectedManutencao.nroManutencao}</span>
                </div>
              </div>
            )}
          </div>

          <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
            <FormContainer title="Dados da solicitação" arrangement="fullRow" border>
              <div className="w-full flex flex-col  gap-4">
                <DefaultFormRadioGroupInput
                  name='status'
                  label='Status'
                  options={analiseOptions}
                  onChangeValue={(value) => {
                    if (value === 3) {
                      viewModel.handleSubmitManutencao();
                    }
                  }}
                  reactHookForm={viewModel.hookForm}
                />

                <div className="w-full grid grid-cols-2 gap-4">
                  <DropDownFuncionario
                    name="idFuncionarioSolicitante"
                    label="Solicitante "
                    readOnly
                    reactHookForm={viewModel.hookForm}
                  />

                  <DropDownCentroCusto
                    name="idCentroCusto"
                    label="Centro de Custo"
                    required
                    readOnly
                    reactHookForm={viewModel.hookForm}
                  />
                </div>

                <div className="w-full grid grid-cols-2 gap-4">
                  <FormDatePickerInput
                    name="dataSolicitacao"
                    label="Data Solicitação"
                    readOnly
                    reactHookForm={viewModel.hookForm}
                  />

                  <DefaultFormAutocomplete
                    name='idMaquinaEquip'
                    label='Máquina/Equipamento'
                    options={viewModel.ddlMaquinaEquip ?? []}
                    getOptionKey={x => x.id}
                    getOptionLabel={x => x.title}
                    readOnly
                    reactHookForm={viewModel.hookForm}
                  />

                </div>

                <DefaultFormInput
                  name="descricao"
                  label="Descrição do Problema"
                  readOnly
                  multiline
                  rows={5}
                  reactHookForm={viewModel.hookForm}
                />
              </div>

            </FormContainer>
            {
              (viewModel.selectedStatus === 2) &&
              <div>
                <fieldset disabled={false}>
                  <FormContainer title="Detalhes da Reprovação" arrangement="fullRow" border>
                    <div className="w-full flex flex-col  gap-4">
                      <div className="w-full grid grid-cols-2 gap-4">
                        <DropDownFuncionario
                          name="idFuncionarioAprovacao"
                          label="Reprovado por "
                          reactHookForm={viewModel.hookForm}
                        />

                        <FormDatePickerInput
                          name="dataAprovacao"
                          label="Data"
                          readOnly
                          reactHookForm={viewModel.hookForm}
                        />

                      </div>

                      <DefaultFormInput
                        name="motivoReprovacao"
                        label="Motivo"
                        multiline
                        rows={5}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                  </FormContainer>

                </fieldset>
              </div>
            }
            {
              (viewModel.selectedStatus === 1 || viewModel.selectedStatus === 3) &&
              <div>
                <fieldset disabled={false}>
                  <FormContainer title="Detalhes da Aprovação" arrangement="fullRow" border>
                    <div className="w-full flex flex-col  gap-4">
                      <div className="flex flex-col items-start w-full gap-4">
                        <FormRadioGroupInput
                          name="tipoManutencao"
                          label="Tipo de Manutenção"
                          readOnly={viewModel.selectedStatus === 3}
                          options={[
                            { id: 0, label: "Interna" },
                            { id: 1, label: "Terceirizada" },
                          ]}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="w-full grid grid-cols-2 gap-4">
                        <DropDownFuncionario
                          name="idFuncionarioAprovacao"
                          label="Aprovado por "
                          readOnly={viewModel.selectedStatus === 3}
                          reactHookForm={viewModel.hookForm}
                        />

                        <FormDatePickerInput
                          name="dataAprovacao"
                          label="Data Aprovação"
                          readOnly={viewModel.selectedStatus === 3}
                          reactHookForm={viewModel.hookForm}
                        />

                      </div>


                      <div className="w-full grid grid-cols-2 gap-4">
                        <DefaultFormMoneyInput
                          name='valorOrcamento'
                          label='Valor Orçamento'
                          readOnly={viewModel.selectedStatus === 3}
                          reactHookForm={viewModel.hookForm}
                        />

                        {
                          viewModel.selectedTipo === 1 ?
                            (<DropDownFornecedor
                              name="idFornecedorResponsavel"
                              label="Responsável pela Manutenção"
                              readOnly={viewModel.selectedStatus === 3}
                              reactHookForm={viewModel.hookForm}
                            />)
                            :
                            (
                              <DropDownFuncionario
                                name="idFuncionarioResponsavel"
                                label="Responsável pela Manutenção"
                                readOnly={viewModel.selectedStatus === 3}
                                reactHookForm={viewModel.hookForm}
                              />
                            )
                        }

                      </div>

                      <div className="w-full grid grid-cols-2 gap-4">
                        <FormDatePickerInput
                          name="dataPrevConclusao"
                          label="Data Prevista de Conclusão"
                          readOnly={viewModel.selectedStatus === 3}
                          reactHookForm={viewModel.hookForm}
                        />

                        <FormDatePickerInput
                          name="dataConclusao"
                          label="Data de Conclusão"
                          readOnly={viewModel.selectedStatus === 3}
                          reactHookForm={viewModel.hookForm}
                        />

                      </div>

                      <DefaultFormInput
                        name="observacao"
                        label=" Descrição da Manutenção"
                        readOnly={viewModel.selectedStatus === 3}
                        multiline
                        rows={5}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </FormContainer>

                </fieldset>
              </div>
            }

            {/* ANEXOS */}
            <FormContainer title="Anexo" arrangement="fullRow" border={false}>
              <div className="w-full pb-4 flex flex-col items-start gap-4">
                <div className="w-[40%] justify-start ">
                  <Controller
                    name="arquivo1"
                    control={viewModel.hookForm.control}
                    render={({ field }) =>
                      viewModel.selectedManutencao &&
                        viewModel.selectedManutencao.nomeArquivo1 &&
                        viewModel.selectedManutencao.nomeArquivo1.length > 0 ? (
                        <div className="w-full flex flex-row justify-between items-center">
                          <span
                            className="cursor-pointer"
                            onMouseDown={() => viewModel.handleDownload(1, viewModel.selectedManutencao?.nomeArquivo1 ?? "")}
                          >
                            {viewModel.selectedManutencao.nomeArquivo1 &&
                              viewModel.selectedManutencao.nomeArquivo1.length > 40
                              ? `${viewModel.selectedManutencao.nomeArquivo1.substring(0, 40)}...`
                              : viewModel.selectedManutencao.nomeArquivo1}
                          </span>
                          <IconButton
                            onClick={() =>
                              viewModel.handleArquivoDeleteOpenState(
                                "limparArquivo1",
                                "nomeArquivo1",
                                true,
                              )
                            }
                          >
                            <DynamicIcon
                              nameIcon="DeleteForeverRounded"
                              size={25}
                              className="text-red-500"
                            />
                          </IconButton>
                        </div>
                      ) : (
                        <PrimaryButton
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          disabled={viewModel.saving}
                          startIcon={
                            <DynamicIcon
                              nameIcon="Download"
                              size={25}
                              className="text-white"
                            />
                          }
                        >
                          {field.value
                            ? field.value.name
                            : "Escolher arquivo"}
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(e) =>
                              viewModel.handleFileChange(
                                "nomeArquivo1",
                                "limparArquivo1",
                                e,
                                field.onChange,
                              )
                            }
                            multiple={false}
                          />
                        </PrimaryButton>
                      )
                    }
                  />
                </div>

                <div className="w-[40%] justify-start">
                  <Controller
                    name="arquivo2"
                    control={viewModel.hookForm.control}
                    render={({ field }) =>
                      viewModel.selectedManutencao &&
                        viewModel.selectedManutencao.nomeArquivo2 &&
                        viewModel.selectedManutencao.nomeArquivo2.length > 0 ? (
                        <div className="w-full flex flex-row justify-between items-center">
                          <span
                            className="cursor-pointer"
                            onMouseDown={() => viewModel.handleDownload(2, viewModel.selectedManutencao?.nomeArquivo2 || '')}
                          >
                            {viewModel.selectedManutencao.nomeArquivo2 &&
                              viewModel.selectedManutencao.nomeArquivo2.length > 40
                              ? `${viewModel.selectedManutencao.nomeArquivo2.substring(0, 40)}...`
                              : viewModel.selectedManutencao.nomeArquivo2}
                          </span>
                          <IconButton
                            onClick={() =>
                              viewModel.handleArquivoDeleteOpenState(
                                "limparArquivo2",
                                "nomeArquivo2",
                                true,
                              )
                            }
                          >
                            <DynamicIcon
                              nameIcon="DeleteForeverRounded"
                              size={25}
                              className="text-red-500"
                            />
                          </IconButton>
                        </div>
                      ) : (
                        <PrimaryButton
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          disabled={viewModel.saving}
                          startIcon={
                            <DynamicIcon
                              nameIcon="Download"
                              size={25}
                              className="text-white"
                            />
                          }
                        >
                          {field.value
                            ? field.value.name
                            : "Escolher arquivo"}
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(e) =>
                              viewModel.handleFileChange(
                                "nomeArquivo2",
                                "limparArquivo2",
                                e,
                                field.onChange,
                              )
                            }
                            multiple={false}
                          />
                        </PrimaryButton>
                      )
                    }
                  />
                </div>

                <div className="w-[40%] justify-start">
                  <Controller
                    name="arquivo3"
                    control={viewModel.hookForm.control}
                    render={({ field }) =>
                      viewModel.selectedManutencao &&
                        viewModel.selectedManutencao.nomeArquivo3 &&
                        viewModel.selectedManutencao.nomeArquivo3.length > 0 ? (
                        <div className="w-full flex flex-row justify-between items-center">
                          <span
                            className="cursor-pointer"
                            onMouseDown={() => viewModel.handleDownload(3, viewModel.selectedManutencao?.nomeArquivo3 ?? "")}
                          >
                            {viewModel.selectedManutencao.nomeArquivo3 &&
                              viewModel.selectedManutencao.nomeArquivo3.length > 40
                              ? `${viewModel.selectedManutencao.nomeArquivo3.substring(0, 40)}...`
                              : viewModel.selectedManutencao.nomeArquivo3}
                          </span>
                          <IconButton
                            onClick={() =>
                              viewModel.handleArquivoDeleteOpenState(
                                "limparArquivo3",
                                "nomeArquivo3",
                                true,
                              )
                            }
                          >
                            <DynamicIcon
                              nameIcon="DeleteForeverRounded"
                              size={25}
                              className="text-red-500"
                            />
                          </IconButton>
                        </div>
                      ) : (
                        <PrimaryButton
                          component="label"
                          role={undefined}
                          variant="contained"
                          tabIndex={-1}
                          disabled={viewModel.saving}
                          startIcon={
                            <DynamicIcon
                              nameIcon="Download"
                              size={25}
                              className="text-white"
                            />
                          }
                        >
                          {field.value
                            ? field.value.name
                            : "Escolher arquivo"}
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(e) =>
                              viewModel.handleFileChange(
                                "nomeArquivo3",
                                "limparArquivo3",
                                e,
                                field.onChange,
                              )
                            }
                            multiple={false}
                          />
                        </PrimaryButton>
                      )
                    }
                  />
                </div>
              </div>
            </FormContainer>
          </div>
        </div>

        {
          <BottomBar>
            <div className="w-full h-full items-center justify-between flex p-4 gap-4">

              <div>
                {
                  isValidId(viewModel.selectedManutencao) &&
                  <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                    <span className="text-xs">
                      Historico de alterações
                    </span>
                  </PrimaryButton>
                }
              </div>

              <div className="w-full flex justify-end items-center gap-4 p-4">
                <div className="p-2 cursor-pointer font-semibold" onClick={() => window.history.back()}>
                  Cancelar
                </div>

                <div className="w-[130px]">
                  {viewModel.loading ? (
                    <PrimaryButton>Salvando...</PrimaryButton>
                  ) : (
                    <PrimaryButton type="submit" startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
                </div>
              </div>
            </div>
          </BottomBar>
        }
      </form>

      {/* ARQUIVOS */}

      <DeleteDialog
        open={viewModel.openDeleteArquivoModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleArquivoDeleteOpenState(null, null, false)
        }
        title={`Você realmente deseja excluir este arquivo?`}
        onDelete={viewModel.handleConfirmarDeletarArquivo}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>


  );
};
